export const DamageRptConstants ={
    GETALL_REQUEST: 'DAMAGE_GETALL_REQUEST',
    GETALL_SUCCESS: 'DAMAGE_GETALL_SUCCESS',
    GETALL_FAILURE: 'DAMAGE_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'DAMAGE_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'DAMAGE_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'DAMAGE_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}